import type { AmazonBuilding } from "../../api/hooks/useAmazonOverview";

/** The code a building's Site details page is reached by: its site code, else its project. */
export const siteCode = (b: Pick<AmazonBuilding, "site_code" | "project_id">): string =>
  b.site_code || b.project_id;
